module.exports = __webpack_public_path__ + "static/media/gift-for-you.53e1780b.jpeg";